(function () {
    'use strict';

    angular
        .module('externalPartyEditModule')
        .controller('ODDExternalPartyAddController', Controller);

    Controller.$inject = ['$scope', '$state', 'businessUnit'];

    function Controller($scope, $state, businessUnit) {
        $scope.businessUnit = businessUnit;
        $scope.externalParty = {};

        // Go To External Party List
        $scope.goToExternalPartyList = function () {
            $state.go('odd.campaignStatusMgmt');
        };
    }
})();